import { render } from "./SolutionItem.vue?vue&type=template&id=0521027a"
import script from "./SolutionItem.vue?vue&type=script&lang=js"
export * from "./SolutionItem.vue?vue&type=script&lang=js"

import "./SolutionItem.vue?vue&type=style&index=0&id=0521027a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__